import { render, staticRenderFns } from "./ComparePercentageComponent.vue?vue&type=template&id=9e926272&scoped=true&"
import script from "./ComparePercentageComponent.vue?vue&type=script&lang=js&"
export * from "./ComparePercentageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e926272",
  null
  
)

export default component.exports